module.exports = __webpack_public_path__ + "0ea1509564dc55c6515b1a70af376357.svg";